var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#heart_svg__clip0_64_2545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.185 3.947l.397.52.397-.52c.057-.074.103-.137.144-.194.079-.109.14-.193.225-.282 2.036-2.134 5.33-2.134 7.367 0 2.047 2.144 2.05 5.631.005 7.778l-8.138 8.06-8.138-8.06C.4 9.102.401 5.615 2.45 3.471c2.037-2.134 5.33-2.134 7.367 0 .085.089.146.173.225.282.041.057.087.12.144.194z",
    stroke: "#000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "heart_svg__clip0_64_2545"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.412 .039)",
    d: "M0 0h20.34v21.305H0z"
  })))));
}
export default SvgHeart;